import Vue from 'vue';
import debounce from 'lodash/debounce';

let subscribers = [];
let elements = [];

const setViewportWidth = (el) => {
  const width = document.documentElement.clientWidth;
  el.style.setProperty('--viewport-width', `${width}px`);
};

const onWindowResize = debounce(() => {
  const width = document.documentElement.clientWidth;
  const height = document.documentElement.clientHeight;
  subscribers.forEach((f) => {
    f({ width, height });
  });
  elements.forEach((el) => {
    setViewportWidth(el);
  });
}, 100);

const addResizeWatcher = () => {
  if (elements.length === 1) {
    window.addEventListener('resize', onWindowResize);
  }
};

const removeResizeWatcher = () => {
  if (elements.length === 0) {
    window.removeEventListener('resize', onWindowResize);
  }
};

Vue.directive('viewport-width', {
  bind(el, binding) {
    if (binding.value) {
      subscribers.push(binding.value);
    }
    elements.push(el);
    addResizeWatcher();
  },
  inserted(el) {
    setViewportWidth(el);
  },
  update(el) {
    setViewportWidth(el);
  },
  unbind(el, binding) {
    if (binding.value) {
      subscribers = subscribers.filter((f) => f !== binding.value);
    }
    elements = elements.filter((e) => e !== el);
    removeResizeWatcher();
  },
});
